import { createSlice } from "@reduxjs/toolkit";
import { REDUX_CONSTANTS } from "../action-constants";

export const initialauthState = {};

export const commonSlice = createSlice({
  name: REDUX_CONSTANTS.COMMON.FEATURE_KEY,
  initialState: initialauthState,
  reducers: {},
});

export const commonReducer = commonSlice.reducer;
